<article class="nt-card" *ngIf="notificacao"
         [style.--nt-cor]="visual.cor" [style.--nt-cor-suave]="visual.corSuave">

  <a *ngIf="montada.capaUrl; else barra" class="nt-capa"
     [attr.href]="montada.capaLink || null" target="_blank" rel="noopener noreferrer"
     (click)="montada.capaLink && clicou(montada.capaLink)">
    <img [src]="montada.capaUrl" alt="">
  </a>
  <ng-template #barra><div class="nt-barra"></div></ng-template>

  <header class="nt-head">
    <div class="nt-tags">
      <span class="nt-badge"><mat-icon>{{ visual.icone }}</mat-icon>{{ visual.rotulo }}</span>
      <span class="nt-origem" *ngIf="notificacao.fromInfokaw" matTooltip="Enviada pela Infokaw">
        <mat-icon>verified</mat-icon>Infokaw
      </span>
      <span class="nt-prazo" *ngIf="diasRestantes !== null">
        <mat-icon>schedule</mat-icon>
        {{ diasRestantes === 0 ? 'Termina hoje' : diasRestantes === 1 ? 'Termina amanhã' : 'Faltam ' + diasRestantes + ' dias' }}
      </span>
    </div>
    <h1 class="nt-titulo">{{ titulo }}</h1>
    <div class="nt-meta" *ngIf="notificacao.inicio || notificacao.validade">
      <span *ngIf="notificacao.inicio">Publicada em {{ notificacao.inicio | date:'dd/MM/yyyy' }}</span>
      <span *ngIf="notificacao.inicio && notificacao.validade"> · </span>
      <span *ngIf="notificacao.validade">válida até {{ notificacao.validade | date:'dd/MM/yyyy' }}</span>
    </div>
  </header>

  <div class="nt-body" *ngIf="corpo" [style.font-size.px]="15 * zoom" [innerHTML]="corpo"></div>

  <div class="nt-cta" *ngIf="montada.ctaUrl">
    <a class="nt-cta-btn" [href]="montada.ctaUrl" target="_blank" rel="noopener noreferrer"
       (click)="clicou(montada.ctaUrl)">
      {{ montada.ctaTexto }}<mat-icon>arrow_forward</mat-icon>
    </a>
  </div>

  <section class="nt-detalhes" *ngIf="montada.detalhes as d">
    <h5><mat-icon>info</mat-icon>Detalhes técnicos</h5>
    <dl>
      <ng-container *ngIf="d.certificado_vencimento">
        <dt>Vencimento</dt><dd>{{ d.certificado_vencimento | date:'dd/MM/yyyy HH:mm' }}</dd>
      </ng-container>
      <ng-container *ngIf="d.dias_para_vencer">
        <dt>Dias para vencer</dt><dd><strong>{{ d.dias_para_vencer }}</strong></dd>
      </ng-container>
      <ng-container *ngIf="d.cnpj">
        <dt>CNPJ</dt><dd>{{ d.cnpj }}</dd>
      </ng-container>
      <ng-container *ngIf="d.status">
        <dt>Status</dt>
        <dd [ngSwitch]="d.status">
          <span *ngSwitchCase="'VENCIDO'" class="nt-st nt-st-ruim">Vencido</span>
          <span *ngSwitchCase="'EXPIRANDO'" class="nt-st nt-st-alerta">Expirando</span>
          <span *ngSwitchCase="'EXPIRING'" class="nt-st nt-st-alerta">Expirando</span>
          <span *ngSwitchCase="'VALIDO'" class="nt-st nt-st-bom">Válido</span>
          <span *ngSwitchCase="'VALID'" class="nt-st nt-st-bom">Válido</span>
          <span *ngSwitchDefault>{{ d.status }}</span>
        </dd>
      </ng-container>
      <ng-container *ngIf="d.filial_id">
        <dt>Filial</dt><dd>{{ d.filial_id }}</dd>
      </ng-container>
      <ng-container *ngIf="d.criacao">
        <dt>Criação</dt><dd class="nt-fraco">{{ d.criacao | date:'dd/MM/yyyy HH:mm' }}</dd>
      </ng-container>
    </dl>
  </section>
</article>
